import { connect } from "react-redux";
import Conversion from "../Components/Conversions/Conversion";
import { getMDLData, getMDLDataDone, downLoadMDL, showMDLInPatternAssistant } from "../store/actions/actions";

const mapStateToProps = (state) => {
  return {
    locale: state.locale,
    enabledownload: state.enabledownload,
    converters: state.converters,
  };
};

const mapDispatchToProps = {
  getMDLData,
  getMDLDataDone,
  downLoadMDL,
  showMDLInPatternAssistant,
};

export default connect(mapStateToProps, mapDispatchToProps)(Conversion);
